<div id="modal-transport">
  <usb-tab-buttons
    class="btn-tabs"
    [categoryId]="8"
    [activeTab]="tab"
    [quote]="quote"
    [buttonColorActive]="buttonColorActive"
    [buttonTextActive]="buttonTextActive"
    [action]="action"
    [productSelect]="productSelect"
    (tabChange)="onTabSelect($event)"
  >
  </usb-tab-buttons>
</div>

<ng-container *ngIf="quote">
  <div [ngClass]="{ 'd-block': tab === 'product', 'd-none': tab != 'product' }">
    <div class="d-flex flex-column mx-auto" style="height: auto; width: 98%">
      <ng-container *ngFor="let vehicle of vehicles; let vehicleIndex = index">
        <div class="d-flex mb-4" style="border: 1px solid #e7e7e7; border-radius: 6px; min-height: auto">
          <div class="d-flex flex-column pb-3" style="width: 75%; background-color: white; min-height: auto; margin-right: 5px; gap: 25px">
            <!-- Section superior -->
            <div class="d-flex flex-row w-100 h-auto" style="background-color: #ffffff">
              <!-- Section image, stars & name vehicle -->
              <div class="d-flex flex-column" style="margin-top: 21px; border-right: 1px solid #959595; padding-right:
              10px; min-width: 235px;">
                <div class="vehicle-image-container" style="margin-bottom:20px; padding-left: 10px;">
                  <img [src]="imgVehicle(vehicle)" alt="Vehículo" class="vehicle-image" />
                </div>
                <div class="d-flex h-auto align-items-start" style="padding-left: 35px;">
                  <p class="usb-modal-text--body-strong" style="font-size: 19px; margin-bottom: 10px;">
                    {{ vehicle?.vehicle?.name }}
                  </p>
                </div>
                <div class="d-flex h-auto mt-2" style="padding-left: 35px;">
                  <ng-container>
                    <p
                      class="average m-0 d-flex align-items-center"
                      style="margin-top: 8px; gap: 10px;"
                      [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                    >
                      <span class="d-flex align-items-center">
                        <span
                          class="usb-modal-text--body-strong light"
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: black;
                            border-radius: 50%;
                            width: 25px;
                            height: 25px;
                          "
                          >{{ result?.additionalInfo?.comments?.average_stars || 0 * 2 }}</span
                        >
                        <span class="usb-modal-text--body-strong light" *ngIf="result?.additionalInfo?.comments?.average_stars > 0" style="margin-left: 3px">{{
                          getCommentadjective(result?.additionalInfo?.comments?.average_stars)
                        }}</span></span
                      >
                      <span
                        class="usb-modal-text--body-strong light"
                        style="color: #bfbfbf;"
                        [ngStyle]="{
                          color: result?.additionalInfo?.comments?.average_stars > 0 ? 'black' : '#bbbbbb'
                        }"
                      >
                        {{ result?.additionalInfo?.comments?.average_stars > 0 ? "puntuación" : "Sin puntuación" }}</span
                      >
                    </p>
                  </ng-container>
                </div>
                <div
                  class="d-flex flex-row"
                  style="
                    margin-top: 15px;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    gap: 10px;
                    padding-left: 35px;
                  "
                >
                  <div class="d-flex align-items-center justify-content-center content-icons px-1" style="opacity: 50%; background-color: #e2e1e3; width: 45px; height: 45px; border-radius: 50%;" (click)="openVideoModal(vehicle.commercialVideoLink)">
                    <img
                      width="30px"
                      height="30px"
                      src="../../../../../assets/icons/search-result/video.svg"
                      class="custom-tooltip"
                      style="cursor: pointer; opacity: 0.5"
                      tooltip="Video comercial"
                      placement="bottom"
                    />
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-center content-icons px-1"
                    style="margin-top: 2px; opacity: 50%;background-color: #e2e1e3; width: 45px; height: 45px; border-radius: 50%;"
                    (click)="openVideoModal(vehicle?.institutionalVideoLink)"
                  >
                    <img
                      width="30px"
                      height="30px"
                      src="../../../../../assets/icons/search-result/video_inst.svg"
                      class="custom-tooltip"
                      tooltip="Video institucional"
                      placement="bottom"
                      style="cursor: pointer; opacity: 0.5"
                    />
                  </div>
                </div>
              </div>

              <div  style="padding: 0px 25px; width: 100%;">
                <!-- Section cant.pax -->
                <div class="vehicle-info-grid pb-4 mb-4" style="border-bottom: 1px dashed #000000; padding: 0px 20px;">
                  <!-- Columna izquierda: Pasajeros y maletas -->
                  <div class="info-column" style="gap: 20px;">
                    <!-- Pasajeros -->
                    <div class="info-item">
                      <p class="usb-modal-text--body-strong mb-2">Cantidad de pax</p>

                      <div class="info-content" style="gap: 10px;">
                        <img
                          src="../../../../../assets/icons/search-result/persona.svg"
                          class="info-icon"
                          style="width: 23px; height: 23px"
                          alt="Pasajeros"
                        />
                        <p class="usb-modal-text--body m-0">{{ vehicle.vehicle.maxPax }} pasajeros</p>
                      </div>
                    </div>

                    <!-- Puertas -->
                    <div class="info-item">
                      <p class="usb-modal-text--body-strong mb-2">Cantidad de puertas</p>

                      <div class="info-content" style="gap: 10px;">
                        <img
                          src="../../../../../assets/icons/search-result/puerta de auto.svg"
                          class="info-icon"
                          style="width: 23px; height: 23px"
                          alt="Pasajeros"
                        />
                        <p *ngIf="vehicle?.vehicle?.number_of_doors && vehicle?.vehicle?.number_of_doors !== ''; else elseDoors"
                          class="usb-modal-text--body m-0">
                          {{ vehicle?.vehicle?.number_of_doors }} puertas
                        </p>

                        <ng-template #elseDoors>
                          <p class="usb-modal-text--body m-0">N/A</p>
                        </ng-template>
                      </div>
                    </div>

                    <!-- Antiguedad -->
                    <div class="info-item">
                      <p class="usb-modal-text--body-strong mb-2">Antiguedad del vehículo</p>

                      <div class="info-content" style="gap: 10px;">
                        <img
                          src="../../../../../assets/icons/search-result/RENT_A_CAR-01-01.svg"
                          class="info-icon"
                          style="width: 23px; height: 23px"
                          alt="Pasajeros"
                        />
                        <p *ngIf="vehicle?.vehicle?.year && vehicle?.vehicle?.year !== ''; else elseVehicleYear" class="usb-modal-text--body m-0">modelo {{ vehicle?.vehicle?.year }}</p>
                        <ng-template #elseVehicleYear>
                          <p class="usb-modal-text--body m-0">N/A</p>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <!-- Columna derecha: Duración y tiempo de espera -->
                  <div class="info-column" style="align-items: flex-start;">
                    <!-- Maletas -->
                    <div class="info-subgroup">
                      <div class="info-item" style="margin-bottom: 10px;">

                        <!-- Duración -->
                        <div class="info-item" style="border: 1.5px solid #959595; border-radius: 12px; width: auto; padding: 15px 30px; margin-bottom: 15px; min-width: 191px;">
                          <p class="usb-modal-text--body-strong mb-1">Duración</p>
                          <div class="info-content" style="gap: 10px;">
                            <img
                              src="../../../../../assets/icons/search-result/tiempo.svg"
                              class="info-icon"
                              style="width: 25px !important; height: 25px;"
                              alt="Duración"
                            />
                            <p class="usb-modal-text--body m-0">{{ roundTripTime }} minutos</p>
                          </div>
                        </div>

                        <!-- Tiempo de espera -->
                        <div class="info-item" style="border: 1.5px solid #959595; border-radius: 12px; width: auto; padding: 15px 30px;
                        min-width: 191px;">
                          <p class="usb-modal-text--body-strong mb-1">Tiempo de espera</p>
                          <div class="info-content" style="align-items: flex-start !important; gap: 10px;">
                            <img
                              src="../../../../../assets/icons/search-result/tiempo_uso.svg"
                              class="info-icon"
                              style="margin-top: -5px; width: 29px !important; height: 29px"
                              alt="Tiempo de espera"
                            />
                            <div class="info-text-group">
                              <span class="usb-modal-text--body m-0" style="margin-bottom: 4px"
                                >{{ vehicle.timing.entry.entryMaximumWaitingTime }} minutos</span
                              >
                              <p class="usb-modal-text--body m-0">sin costo</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" style="padding: 0px 20px;">
                  <div class="col-12">
                    <p class="usb-modal-text--body-strong mb-2">
                      Cantidad de maletas
                    </p>
                  </div>
                  <div class="col-6">
                    <div class="info-content align-items-start" style="gap: 10px;">
                      <img
                        src="../../../../../assets/icons/search-result/maleta.svg"
                        class="info-icon"
                        style="width: 24px; height: 24px; margin-left: 2px;"
                        alt="Maletas"
                      />
                      <div class="d-flex flex-column">
                        <p class="usb-modal-text--body m-0 mb-2" style="line-height: 1.3;">{{ vehicle.vehicle.bag.maxBag }} maletas grandes <br /> por vehículo</p>
                      </div>
                    </div>
                    <div class="d-flex flex-column" style="background-color: #ececec; padding: 20px 20px 20px 35px; border-radius: 4px; width: 191px;">
                      <p class="usb-modal-text--body m-0" style="font-size: 12px;"><span style="font-weight: 500;">max:</span> 23kg</p>
                      <p class="usb-modal-text--body m-0" style="font-size: 12px;"><span style="font-weight: 500;" >dimensiones: </span> ≤ 158 cm</p>
                    </div>
                  </div>
                  <div class="col-6 pl-0">
                    <div class="info-content" style="align-items: flex-start !important; gap: 5px;">
                      <img
                        src="../../../../../assets/icons/search-result/carry.svg"
                        class="info-icon"
                        style="width: 25px !important; height: 25px; margin-top: -5px"
                        alt="Maletas de mano"
                      />
                      <div class="info-text-group">
                        <span class="usb-modal-text--body m-0" style="margin-bottom: 4px; line-height: 1.3;">{{ vehicle.vehicle.bag.numberHandbags || 0 }} maletas medianas</span>
                        <p class="usb-modal-text--body m-0 mb-2">por vehículo</p>
                      </div>
                    </div>
                    <div class="d-flex flex-column" style="background-color: #ececec; padding: 20px 30px; border-radius: 4px; width: 191px;">
                      <div class="d-flex flex-column" >
                        <p class="usb-modal-text--body m-0" style="font-size: 12px;"><span style="font-weight: 500;">max:</span> 23kg</p>
                        <p class="usb-modal-text--body m-0" style="font-size: 12px;"><span style="font-weight: 500;" >dimensiones: </span> ≤ 158 cm</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- lower section -->
            <div
              class="d-flex flex-row pb-3"
              style="
                background-color: #f5f5f5;
                border-radius: 6px;
                min-height: auto;
                padding-top: 20px;
                padding-left: 18px;
                margin-left: 18px;
                margin-right: 18px;
              "
            >
              <div class="h-auto mt-2 ml-2" style="width: 30%">
                <p class="usb-modal-text--body-strong mb-3">Incluidos</p>
                <p *ngIf="validateIncludedAmenities(vehicle)" class="usb-modal-text--body">N/A</p>
                <ng-container *ngFor="let amenities of vehicle.amenities">
                  <div class="d-flex align-items-start" style="gap: 0.25em" *ngIf="amenities.included">
                    <i class="bi bi-check" style="color: black; margin-top: -4px"></i>
                    <p class="usb-modal-text--body mb-0">
                      {{ amenities.name }}
                    </p>
                  </div>
                </ng-container>
              </div>

              <div class="h-auto mt-2" style="width: 70%; padding: 0px 25px;">
                <p class="usb-modal-text--body-strong mb-3">Adicionales</p>
                <p *ngIf="validateNotIncludedAmenities(vehicle)" class="usb-modal-text--body">N/A</p>
                <ng-container *ngFor="let amenities of vehicle.amenities; let amenityIndex = index">
                  <div class="d-flex flex-column justify-content-center mb-3" *ngIf="!amenities.included">
                    <div class="d-flex" style="gap: 0.5em">
                      <input
                        type="checkbox"
                        class="black-checkbox"
                        (change)="toggleAmenity(vehicle, amenities)"
                        [checked]="isAmenitySelected(vehicle, amenities)"
                      />

                      <div class="d-flex flex-column" style="gap: 5px;">
                        <div class="d-flex" style="gap: 5px;">
                          <p class="usb-modal-text--body mb-1">
                            {{ amenities.name }}
                            <span class="usb-modal-text--body mb-0" style="font-weight: 600">
                              ({{ currencyAgency?.code }}
                              {{
                                amenities.priceProf
                                  | currencyConverterPure: vehicle.pricing.currency : currencyAgency.code : currencies
                                  | number: "1.2-2"
                              }})
                            </span>
                          </p>
                          <usb-tooltip-convert-amount
                            [clientsSettingAppBooking]="clientSetting"
                            [currencyProduct]="vehicle?.pricing?.currency"
                            [valueProduct]="amenities.priceProf"
                          >
                          </usb-tooltip-convert-amount>
                        </div>

                        <div
                          class="d-flex mt-1 align-items-center"
                          style="gap: 0.5em"
                          *ngIf="
                            amenities.type === 'Baggage' &&
                            amenities?.maximumQuantity &&
                            amenities?.minimumQuantity &&
                            amenities?.maximumQuantity >= amenities?.minimumQuantity
                          "
                        >
                          <p class="mb-0 usb-modal-text--body">Cantidad:</p>
                          <mat-select
                            [formControl]="getQuantityControl(vehicle, amenities)"
                            class="form-control usb-modal-text--body"
                            [disabled]="!isAmenitySelected(vehicle, amenities)"
                            style="
                              height: 30px;
                              width: 150px;
                            "
                            [ngStyle]="{ 'background-color': !isAmenitySelected(vehicle, amenities) ? '#ececec' : 'white' }"
                          >
                            <mat-option
                              *ngFor="let qty of getQuantityOptions(amenities)"
                              [disabled]="!isAmenitySelected(vehicle, amenities)"
                              [value]="qty"
                            >
                              {{ qty }} {{ qty === 1 ? "unidad" : "unidades" }}
                              <span *ngIf="qty <= (amenities.minimumQuantity || 0)" style="color: green"> (Gratis) </span>
                              <span *ngIf="qty > (amenities.minimumQuantity || 0)" style="color: #666">
                                (+ {{ currencyAgency?.code }}
                                {{
                                  (qty - (amenities.minimumQuantity || 0)) * amenities.priceProf
                                    | currencyConverterPure: vehicle.pricing.currency : currencyAgency.code : currencies
                                    | number: "1.2-2"
                                }})
                              </span>
                            </mat-option>
                          </mat-select>
                        </div>
                        <div
                          class="d-flex mt-1 align-items-center"
                          style="gap: 0.5em"
                          *ngIf="amenities.type === 'Language' && amenities?.options?.length > 0"
                        >
                          <p class="mb-0 usb-modal-text--body" style="width: 53.18px">Idioma:</p>
                          <mat-select
                            [disabled]="!isAmenitySelected(vehicle, amenities)"
                            [formControl]="getLanguageControl(vehicle, amenities)"
                            class="form-control usb-modal-text--body"
                            style="
                              height: 24px;
                              width: 25%;
                              padding-top: 2px;
                            "
                            [ngStyle]="{ 'background-color': !isAmenitySelected(vehicle, amenities) ? '#ececec' : 'white' }"
                          >
                            <mat-option disabled value="">Seleccione</mat-option>
                            <ng-container *ngFor="let language of amenities.options">
                              <mat-option [value]="language" [disabled]="!isAmenitySelected(vehicle, amenities)">
                                {{ language }}
                              </mat-option>
                            </ng-container>
                          </mat-select>
                        </div>
                        <div class="d-flex mt-1 align-items-center" style="gap: 0.5em" *ngIf="amenities.type === 'PetsAllowed'">
                          <p class="mb-0 usb-modal-text--body">Cantidad:</p>
                          <mat-select
                            [formControl]="getQuantityControl(vehicle, amenities)"
                            class="form-control usb-modal-text--body"
                            [disabled]="!isAmenitySelected(vehicle, amenities)"
                            style="
                              height: 24px;
                              width: auto;
                              min-width: 150px;
                              padding-top: 2px;
                            "
                            [ngStyle]="{ 'background-color': !isAmenitySelected(vehicle, amenities) ? '#ececec' : 'white' }"
                          >
                            <mat-option
                              *ngFor="let qty of getQuantityPetsOptions(vehicle)"
                              [disabled]="!isAmenitySelected(vehicle, amenities)"
                              [value]="qty"
                            >
                              {{ qty }} {{ qty === 1 ? "mascota" : "mascotas" }}
                              <span *ngIf="qty <= (vehicle?.vehicle?.capacities?.pets?.minimum || 0)" style="color: green"> (Gratis) </span>
                              <span *ngIf="qty > (vehicle?.vehicle?.capacities?.pets?.maximum || 0)" style="color: #666">
                                (+ {{ currencyAgency?.code }}
                                {{
                                  (qty - (amenities.minimumQuantity || 0)) * amenities.priceProf
                                    | currencyConverterPure: vehicle.pricing.currency : currencyAgency.code : currencies
                                    | number: "1.2-2"
                                }})
                              </span>
                            </mat-option>
                          </mat-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Section Price -->
          <div class="d-flex flex-column align-items-center" style="border-left: 1px solid #e7e7e7; width: 25%">
            <div class="d-flex flex-column w-75" style="padding-bottom: 45px; margin-top: 71px">
              <div class="w-100 d-flex">
                <p class="w-75 usb-modal-text--subtitle semi-bold mb-0" style="font-size: 22px;">Tarifa total</p>
              </div>

              <div class="w-100 h-50 d-flex">
                <div class="d-flex flex-column">
                  <div class="d-flex">
                    <div class="d-flex">
                      <p
                        class="usb-modal-text--body-strong mb-0"
                        [ngStyle]="{
                          'font-size':
                            (vehicle?.netPriceBookingWithIncluded &&
                            vehicle?.netPriceBookingWithIncluded > vehicle.profility.netPriceBooking
                              ? vehicle?.netPriceBookingWithIncluded
                              : vehicle.profility.netPriceBooking
                            )
                            | currencyConverterPure: vehicle.pricing.currency : currencyAgency.code : currencies
                            | dynamicFontSize: 21 : fontSizeAdjustments
                        }"
                      >
                        {{ currencyAgency?.code }}
                        {{
                          (vehicle?.netPriceBookingWithIncluded && vehicle?.netPriceBookingWithIncluded > vehicle.profility.netPriceBooking
                            ? vehicle?.netPriceBookingWithIncluded
                            : vehicle.profility.netPriceBooking
                          )
                            | currencyConverterPure: vehicle.pricing.currency : currencyAgency.code : currencies
                            | number: "1.2-2"
                        }}
                      </p>
                      <usb-tooltip-convert-amount
                        [clientsSettingAppBooking]="clientSetting"
                        [currencyProduct]="vehicle.pricing?.currency"
                        [valueProduct]="vehicle.totalPriceProf"
                      >
                      </usb-tooltip-convert-amount>
                    </div>
                  </div>

                  <p *ngIf="vehicle.pricing?.currency !== currencyAgency?.code" class="mb-0 usb-modal-text--body-strong" style="font-size: 18px;">
                    {{ vehicle.pricing.currency }}
                    {{
                      (vehicle?.netPriceBookingWithIncluded && vehicle?.netPriceBookingWithIncluded > vehicle.profility.netPriceBooking
                        ? vehicle?.netPriceBookingWithIncluded
                        : vehicle.profility.netPriceBooking
                      ) | number: "1.2-2"
                    }}
                  </p>

                  <span class="mb-0 usb-modal-text--body-strong light" style="font-size: 14.7px;">Imp. incluidos</span>

                  <div *ngIf="vehicle.pricing?.currency === currencyAgency?.code" style="height: 13px; line-height: 1.1"></div>
                </div>
              </div>
            </div>
            <!-- reembolsables -->
            <div class="d-flex flex-column w-75" style="border-top: 1.5px solid #e7e7e7; padding-top: 40px">
              <div class="w-100 d-flex flex-column">
                <div class="d-flex flex-column w-100">
                  <ng-container *ngIf="vehicle?.pricing?.rateClass === 'R'">
                    <div class="d-flex w-75 justify-content-start align-items-start">
                      <p
                        class="mb-0 usb-modal-text--body-strong"
                        style="color: #00d096; text-transform: capitalize;"
                      >
                        REEMBOLSABLE
                      </p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="vehicle?.pricing?.rateClass === 'NR'">
                    <div class="d-flex w-75 justify-content-start align-items-start">
                      <p
                        class="mb-0 usb-modal-text--body-strong"
                        style="color: #b70d35; text-transform: capitalize;"
                      >
                        NO REEMBOLSABLE
                      </p>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div *ngIf="vehicle?.pricing?.rateClass === 'R'" class="w-100 d-flex flex-column">
                <div class="d-flex flex-column mb-3 w-75">
                  <ng-container
                    *ngIf="
                      vehicle?.timing?.entry?.entryCancellationPolicies && vehicle?.timing?.entry?.entryCancellationPolicies.length > 0
                    "
                  >
                    <div class="d-flex flex-column align-items-start">
                      <p
                        class="mb-0 usb-modal-text--body-strong"
                        style="color: #00d096;"
                      >
                        Cancelación gratis
                      </p>
                      <p
                        class="mb-0 usb-modal-text--body-strong light"
                        style="color: #00d096;"
                      >
                        hasta el
                        {{ vehicle?.timing?.entry?.entryCancellationPolicies[0]?.from | date: "dd/MM/yyyy" }}
                      </p>
                      <p
                        class="mb-0 usb-modal-text--body-strong light"
                        style="color: #00d096;"
                      >
                        a las
                        {{ vehicle?.timing?.entry?.entryCancellationPolicies[0]?.from | date: "hh:ss" }}
                      </p>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      vehicle?.timing?.entry?.entryCancellationPolicies && vehicle?.timing?.entry?.entryCancellationPolicies.length === 0
                    "
                  >
                    <p class="mb-0 vehicle-middle-pollician-text line-height" style="font-size: 11px; font-weight: 200">N/A</p>
                  </ng-container>
                </div>
              </div>

              <div *ngIf="vehicle?.pricing?.rateClass === 'NR'" class="w-100 d-flex flex-column">
                <div class="d-flex flex-column mb-3 w-75 align-items-center">
                  <ng-container>
                    <div class="d-flex flex-column align-items-start">
                      <p class="mb-0 usb-modal-text--body-strong" style="color: #b70d35;">
                        Cancelación con 100% de cargo
                      </p>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div *ngIf="!validPaymentConditionAgencyAvailable(vehicle?.pricing?.rateClass)" class="d-flex mx-auto mb-3">
              <p class="mb-0 usb-modal-text--body-strong light mx-2 ml-3" style="color: #b70d35;">
                No es posible seleccionar un producto no reembolsable debido a las condiciones de pago de la agencia
              </p>
            </div>

            <div
              *ngIf="validPaymentConditionAgencyAvailable(vehicle?.pricing?.rateClass) && !canSelectVehicle(vehicle)"
              class="d-flex mx-auto mb-3"
            >
              <p class="mb-0 usb-modal-text--body-strong light mx-2 ml-3" style="color: #b70d35">
                No hay suficientes pasajeros disponibles para este vehículo
              </p>
            </div>

            <div class="d-flex flex-column" style="width: 205.94px; margin-top: 2rem">
              <button
                *ngIf="validPaymentConditionAgencyAvailable(vehicle?.pricing?.rateClass) && canSelectVehicle(vehicle)"
                type="button"
                class="btn btn-select-vehicle"
                style="font-size: 16pxi !important; font-weight: 400 !important;"
                [ngStyle]="{ 'background-color': buttonColorActive }"
                (click)="productSelected(vehicleIndex, vehicle)"
              >
                Seleccionar
              </button>

              <button
                *ngIf="!canSelectVehicle(vehicle) && validPaymentConditionAgencyAvailable(vehicle?.pricing?.rateClass)"
                type="button"
                class="btn btn-select-vehicle"
                disabled
                style="background-color: #cccccc; color: #666666; font-size: 16px !important; font-weight: 400 !important;"
              >
                No disponible
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<div [ngClass]="{ 'd-block': tab === 'info', 'd-none': tab != 'info' }" style="position: relative; margin-bottom: 70px">
  <usb-vehicle-info-transfer
    *ngIf="productSelect"
    [product]="product"
    [numberOfSeats]="numberOfSeats"
    [numberOfDoors]="numberOfDoors"
    [maxPax]="maxPax"
    [numberLargeSuitcases]="numberLargeSuitcases"
    [numberMediumSuitcases]="numberMediumSuitcases"
    [numberHandBag]="numberHandBag"
    [infoTransfer]="infoTransfer"
    [currencySelected]="currencySelected"
    [currencies]="currencies"
    [currencyAgency]="currencyAgency"
    [totalQty]="totalQty"
    [fliyingInfo]="fliyingInfo"
    [formTransport]="formTransport"
    [clientSetting]="clientSetting"
    [productSelect]="productSelect"
    [payload]="payload"
    [quote]="quote"
  >
  </usb-vehicle-info-transfer>

  <div
    *ngIf="quote && productSelected"
    class="d-flex align-items-center mx-auto justify-content-between"
    style="
      height: 120px;
      gap: 1em;
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50.65%);
      width: 100%;
      max-width: 1223px;
      border-top: 2px solid #bfbfbf;
      padding: 2em 5.5em 2.5em 5.5em;
      background-color: white;
    "
  >
    <div class="d-flex flex-column" style="width: 100%">
      <p class="room-selected-title">{{ product?.vehicle?.name }} {{ product?.vehicle?.type }}</p>
      <!-- <p class="description-selected "> {{formTransport?.firstqtyAdults}} {{formTransport?.firstqtyAdults === 1 ? 'adulto' : 'adultos'}} - {{formTransport?.firstqtyChilds}} {{formTransport?.firstqtyChilds > 1 ? 'niños' : 'niño'}}</p>
            <p class="description-selected ">{{formTransport?.firstOrigin?.name }} - {{formTransport?.firstDestination?.name}}</p>
            <p class="description-selected ">{{formTransport?.firstArrivalDate | date: 'dd/MMM/yyyy'}} - {{product?.timing?.entry?.entryTravelTime}} minutos</p> -->
    </div>
    <div class="d-flex align-items-center justify-content-end" style="width: 100%; gap: 1em">
      <div class="d-flex flex-column align-items-end justify-content-center">
        <p
          class="mb-0"
          style="
            font-family: &quot;Rubik&quot;, serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 1;
            color: #666666;
            margin-right: 16px;
          "
        >
          Total Tarifa Neta
        </p>
        <div class="d-flex">
          <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 27px; font-weight: 500; line-height: 1; color: black">
            {{ currencyAgency?.code }}
            {{ totalQty | currencyConverterPure: currencySelected : currencyAgency.code : currencies | number: "1.2-2" }}
          </p>
          <usb-tooltip-convert-amount [clientsSettingAppBooking]="clientSetting" [currencyProduct]="totalQty" [valueProduct]="totalQty">
          </usb-tooltip-convert-amount>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-continue"
        [ngStyle]="{ 'background-color': buttonColorActive, color: buttonTextActive }"
        (click)="continue(product)"
        [disabled]="!productSelect"
      >
        Continuar
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="tab === 'comments'">
  <div [ngClass]="{ 'd-block': tab === 'comments', 'd-none': tab != 'comments' }">
    <usb-comments
      [clientSetting]="clientSetting"
      [payload]="payload"
      [productId]="product?.productId"
      [action]="action"
      (closeModal)="closeModal()"
    >
    </usb-comments>
  </div>
</ng-container>
